import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuStylingOption} from '@Components/contextual-menu/components/contextual-menu-styling-option';
import {TextHorizontalAlignType} from '@PosterWhiteboard/classes/text-styles.class';
import type {IconStates} from '@Components/contextual-menu/components/styling-options';
import {IconSize} from '@Components/icon-v2/icon.types';

interface ItemBaseAlignmentOptionProps {
  selectedAlignment: TextHorizontalAlignType;
  onClickAlignmentOption(id: TextHorizontalAlignType): void;
  showLargeIcons?: boolean;
  text?: string;
}

export function ItemBaseAlignmentOption({showLargeIcons = false, text = window.i18next.t('pmwjs_alignment'), ...props}: ItemBaseAlignmentOptionProps): ReactElement<any> {
  const getAlignmentOptionsData = (): Array<IconStates> => {
    return [
      {
        id: TextHorizontalAlignType.LEFT,
        icon: 'icon-align-left',
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
        isSelected: props.selectedAlignment === TextHorizontalAlignType.LEFT,
      },
      {
        id: TextHorizontalAlignType.CENTER,
        icon: 'icon-align-center',
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
        isSelected: props.selectedAlignment === TextHorizontalAlignType.CENTER,
      },
      {
        id: TextHorizontalAlignType.RIGHT,
        icon: 'icon-align-right',
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
        isSelected: props.selectedAlignment === TextHorizontalAlignType.RIGHT,
      },
      {
        id: TextHorizontalAlignType.JUSTIFY,
        icon: 'icon-align-block',
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
        isSelected: props.selectedAlignment === TextHorizontalAlignType.JUSTIFY,
      },
    ];
  };

  const onClickHandler = (clickedId: TextHorizontalAlignType): void => {
    props.onClickAlignmentOption(clickedId);
  };

  return <ContextualMenuStylingOption id="text-item-alignment-option" onClick={onClickHandler} label={text} data={getAlignmentOptionsData()} />;
}
